import { ENDPOINTS, get } from '~/api'
import {
  resetAccountDetailList,
  resetAccountList,
  setAccountDetailList,
  setAccountList,
} from '~/store/accounts/actions'
import { ActionTypes, Dispatch } from '~/store/types'
import { ASSET_ACTIONS } from './const'
import { Account, DashboardAssetListResponse } from './types'

const setAssetList = (accountList: Account[], totalBalance: number) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch({
    type: ASSET_ACTIONS.SET_ASSET_LIST,
    accountList,
    totalBalance,
  })
}

const setErrorState = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({ type: ASSET_ACTIONS.SET_ERROR_STATE })
}

const setLoadingState = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({ type: ASSET_ACTIONS.SET_LOADING_STATE })
}

export const resetAssetList = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({ type: ASSET_ACTIONS.RESET_ASSET_LIST })

  // TODO(benedictkhoo): remove after assets unification is done
  dispatch(resetAccountList())
  dispatch(resetAccountDetailList())
}

export const fetchAssetList = () => async (dispatch: Dispatch<ActionTypes>) => {
  dispatch(setLoadingState())

  try {
    const res = (await get(ENDPOINTS.API_DASHBOARD_ASSETS)) as DashboardAssetListResponse

    dispatch(setAssetList(res.assets, res.totalBalance))

    // TODO(benedictkhoo): remove after assets unification is done
    dispatch(setAccountList(res.assets))
    dispatch(setAccountDetailList(res.assets))
  } catch (e) {
    dispatch(setErrorState())
  }
}
